export default "__VITE_ASSET__D92$evEr__"